module.exports = __webpack_public_path__ + "static/media/getStarted.a540287d.svg";